import { Box, LinearProgress, Typography } from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import React from "react";

function BidPublishLoader({ mediaProgress = 0 }) {
  const hasUploadProgress = mediaProgress > 0 && mediaProgress < 100;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1600,
        bgcolor: "rgba(12, 34, 50, 0.48)",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        direction: "rtl",
        fontFamily: `${process.env.REACT_APP_FONT || "Assistant"}`,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 390,
          bgcolor: "#fff",
          borderRadius: "20px",
          px: { xs: 2.4, sm: 3 },
          py: { xs: 2.3, sm: 2.7 },
          boxShadow: "0 18px 52px rgba(17, 52, 74, 0.24)",
          border: "1px solid rgba(38, 111, 157, 0.10)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 1.8,
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              flex: "0 0 48px",
              borderRadius: "15px",
              display: "grid",
              placeItems: "center",
              bgcolor: "#EEF7FC",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <AutoAwesomeRoundedIcon
              sx={{
                fontSize: 27,
                color: "#2277A9",
                position: "relative",
                zIndex: 1,
                animation: "biditSpark 1.25s ease-in-out infinite",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                width: 16,
                height: 16,
                borderRadius: "50%",
                bgcolor: "#CDEBFA",
                animation: "biditPulse 1.5s ease-out infinite",
              }}
            />
          </Box>

          <Box sx={{ textAlign: "right", minWidth: 0 }}>
            <Typography
              sx={{
                fontFamily: "inherit",
                fontWeight: 800,
                fontSize: { xs: 19, sm: 20.5 },
                color: "#183B52",
                lineHeight: 1.2,
              }}
            >
              מפרסמים את המכרז שלך
            </Typography>
            <Typography
              sx={{
                fontFamily: "inherit",
                color: "#718493",
                mt: 0.45,
                fontSize: 13.5,
                lineHeight: 1.45,
              }}
            >
              {hasUploadProgress
                ? "מעלים את הקבצים ושומרים את פרטי המכרז..."
                : "שומרים את הפרטים ומעבירים את המכרז לבדיקה..."}
            </Typography>
          </Box>
        </Box>

        <LinearProgress
          variant="indeterminate"
          sx={{
            height: 6,
            borderRadius: 20,
            bgcolor: "#EAF1F5",
            "& .MuiLinearProgress-bar": { borderRadius: 20 },
          }}
        />

        <Typography
          sx={{
            fontFamily: "inherit",
            color: "#8A9AA5",
            textAlign: "center",
            mt: 1.2,
            fontSize: 12.5,
          }}
        >
          אין צורך לרענן את העמוד
        </Typography>
      </Box>

      <style>{`
        @keyframes biditSpark {
          0%, 100% { transform: scale(1) rotate(0deg); }
          50% { transform: scale(1.08) rotate(5deg); }
        }
        @keyframes biditPulse {
          0% { transform: scale(.5); opacity: .45; }
          75% { transform: scale(3); opacity: 0; }
          100% { opacity: 0; }
        }
      `}</style>
    </Box>
  );
}

export default BidPublishLoader;
